import React from "react";
import RoleAssignmentListItem from "../../components/roleAssignment/RoleAssignmentList/RoleAssignmentListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const RoleAssignmentListPage = ()  => {

    useTitle(t`List Role Assignment`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <RoleAssignmentListItem showAdd={true} {...query} />
        </Box>
    )
}

export default RoleAssignmentListPage;
